import customAxios from "./axios";
import CONFIG from "../../config";

export const getAllNotifications = (val) => {
  return customAxios
    .get(
      CONFIG.apiURL + `/Noti/GetAppNotifications?showReadNotifications=${val}`
    )
    .then((res) => {
      let response = res["data"];
      return response;
    });
};

export const markAsRead = (payload) => {
  return customAxios
    .post(CONFIG.apiURL + "/Noti/UpdateNotificationsAsRead", payload)
    .then((res) => {
      let response = res["data"];
      return response;
    });
};

export const getUnreadNotificationCount = (id) => {
  return customAxios
    .get(CONFIG.apiURL + `/Noti/GetCustomerFcmNotificationsUnreadCount?days=${id ?? 14}`)
    .then((res) => {
      let response = res["data"];
      return response;
    });
};

export const snoozeSetOn = (hourNumber, payload) => {
  return customAxios
    .post(
      CONFIG.apiURL + `/Noti/TurnSnoozeOn?snoozeTill=${hourNumber}`,
      payload
    )
    .then((res) => {
      let response = res["data"];
      return response;
    });
};

export const snoozeSetOff = (payload) => {
  return customAxios
    .post(CONFIG.apiURL + `/Noti/TurnSnoozeOff`, payload)
    .then((res) => {
      let response = res["data"];
      return response;
    });
};

export const getArchived = (val) => {
  return customAxios
    .get(
      CONFIG.apiURL + `/Noti/GetAppNotifications?showReadNotifications=${val}`
    )
    .then((res) => {
      let response = res["data"];
      return response;
    });
};
